export default __webpack_public_path__ + "static/media/check-fill-circle.756ea1c6.svg";